import emailjs from "@emailjs/browser";

export async function contact(user) {
  const EMAILJS_SERVICE_ID = "service_3ceep8u";
  const TEMPLATE_ID = "template_o8nafs9";
  const PUBLIC_KEY = "M_zyiaeR2WM9B4pd7";

  try {
    await emailjs.send(
      EMAILJS_SERVICE_ID,
      TEMPLATE_ID,
      {
        name: user.name,
        email: user.email,
        message: user.message,
        title: "Message from MandlaAI",
      },
      PUBLIC_KEY,
    );

    
  } catch (error) {
    console.log(error);
  }
}
